const DEFAULT_LINE_LINK = 'https://lin.ee/tqR1wJD'
const DUPLICATE_ACCOUNT_CONTACT_MESSAGE = 'หมายเลขบัญชีนี้เป็นสมาชิกอยู่แล้วค่ะสอบถามข้อมูลเพิ่มเติมกรุณาติดต่อ admin'

// Mixin to provide settings-aware translations
export default {
  computed: {
    // Dynamic translation replacements
    translationsWithSettings() {
      const lineAt = this.$store.getters['settings/lineAt'] || '@vr1game'
      const linkLine = this.$store.getters['settings/linkLine']

      return {
        lineAt,
        linkLine,
        // Helper method to replace settings in text
        replaceSettings(text) {
          if (!text) return text
          return text.toString()
            .replace(/(^|[^\w.])@[a-z0-9._-]+/gi, (_match, prefix) => `${prefix}${lineAt}`)
            .replace(/https:\/\/lin\.ee\/Cdd1Uol/g, linkLine)
        }
      }
    },
    adminContactLineLink() {
      return this.$store.getters['settings/adminContactLineLink'] || this.$store.getters['settings/linkLine']
    },
    publicLineLink() {
      return this.$store.getters['settings/linkLine'] || DEFAULT_LINE_LINK
    }
  },
  methods: {
    async $showDuplicateAccountContactAlert() {
      if (!this.$store.getters['settings/isSettingsLoaded']) {
        await this.$store.dispatch('settings/fetchSettings')
      }

      const lineLink = this.publicLineLink || DEFAULT_LINE_LINK
      const result = await this.$swal({
        icon: 'error',
        title: 'Error!',
        text: DUPLICATE_ACCOUNT_CONTACT_MESSAGE,
        confirmButtonText: 'ติดต่อแอดมิน'
      })

      if (result && (result.isConfirmed || result.value === true)) {
        window.location.href = lineLink
      }
    },
    $replaceSettings(text) {
      return this.translationsWithSettings.replaceSettings(text)
    },
    // Get translation with dynamic settings replacement
    $tWithSettings(key) {
      const translation = this.$t(key)
      return this.$replaceSettings(translation)
    }
  }
}
